import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import routes from "./config/routes";
import RouteGenerate from "./components/Router";
import { Provider } from "react-redux";
import store from 'store';
import "swiper/swiper.scss";
import "./index.css";

console.log('version: ', '2020.01.14 1.0');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouteGenerate routes={routes} />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
